
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTodoDtoFormGroup() {
return new FormGroup({
    title: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(255)]),
    description: new FormControl<string | undefined>(''),
    assignedToUserId: new FormControl<number | undefined>(undefined),
    meetingId: new FormControl<number | undefined>(undefined),
    meetingAgendaItemId: new FormControl<number | undefined>(undefined),
    dueAt: new FormControl<string | undefined>(''),
    priority: new FormControl<string | undefined>(''),
    status: new FormControl<string | undefined>(''),
})
;
}
      